import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { useAutoNavigate } from '@betterment/js-runtime';
import { Box, Separator } from '@betterment/samba-react';
import { ErrorBoundary, ListRowLoader } from '@betterment/shared-components';

import { ProductRow } from './components/ProductRow';
import { ProductSelectionOptionsDocument } from './graphql/productSelectionOptions.generated';
import { useDisclosuresUpdate } from './hooks/useDisclosuresUpdate';

import StepHeading from '../../../AccountCreationFlow/components/StepHeading';
import { WorkflowLayout } from '../../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../../Shared/urlBuilder';

const Content: React.FC = () => {
  const { data } = useGraphQLQuery(ProductSelectionOptionsDocument, {
    throwOnError: true,
  });

  const options = data?.productOnboardingOptions;
  useDisclosuresUpdate(options);

  if (!options) {
    return (
      <>
        <Separator />
        <ListRowLoader />
        <Separator />
        <ListRowLoader />
        <Separator />
        <ListRowLoader />
        <Separator />
        <ListRowLoader />
        <Separator />
        <ListRowLoader />
      </>
    );
  }

  return (
    <>
      {options.map(option => (
        <React.Fragment key={option.id}>
          <Separator />
          <ProductRow option={option} />
        </React.Fragment>
      ))}
    </>
  );
};

export const ProductSelectionStep: React.FC = () => {
  const navigate = useAutoNavigate();

  return (
    <WorkflowLayout
      feature="add_account"
      pageTitle="What account do you want to open?"
      workflowTitle=""
      onClose={() => navigate(urlBuilder.appHome.absolute())}
    >
      <Box css={{ marginTop: 'space.400', marginBottom: 'space.600' }}>
        <StepHeading>What account do you want to open?</StepHeading>
      </Box>

      <ErrorBoundary>
        <Content />
      </ErrorBoundary>
    </WorkflowLayout>
  );
};
